// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-field-edit-password .form-group {
  position: relative;
}
.data-field-edit-password .form-group .Ccm-Data .mat-mdc-checkbox {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/data-field/data-field-edit/password/password.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAGY;EACI,WAAA;AADhB","sourcesContent":[".data-field-edit-password {\r\n    .form-group {\r\n        position: relative;\r\n\r\n        .Ccm-Data {\r\n            .mat-mdc-checkbox {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
